import React, { useEffect, useState } from 'react'
import FormsList from '../form-creations/FormsList'
import FormCategoriesList from '../form-creations/FormCategoriesList'
import VisitFormResults from './VisitFormResults'
import { useSelector } from 'react-redux'
import DropdownField from '../../../shared/DropdownField'
import { useTranslation } from 'react-i18next'
import { formTypes } from '../../../constants/FormCreationConstants'

const CreateVisitFormEntries = () => {
  const { t } = useTranslation()
  const [selectedFormType, setSelectedFormType] = useState('general')
  const [selectedFormId, setSelectedFormId] = useState(null)
  const [selectedCategoryId, setSelectedCategoryId] = useState(null)
  const [selectedElementFormId, setSelectedElementFormId] = useState(null)
  const { selectedVisitData } = useSelector(state => state?.visits)

  useEffect(() => {
    setSelectedCategoryId(null)
    setSelectedElementFormId(null)
  }, [selectedFormId])
  return (
    <div>
      <div className='grid grid-cols-12 gap-3'>
        <div className='col-span-12 md:col-span-6 xl:col-span-3'>
          <DropdownField
            className='mb-2'
            label={t('Select Form Type')}
            options={formTypes.map(type => ({
              label: t(type.label),
              value: type.value
            }))}
            useFormik={false}
            placeholder={t('Select Form Type')}
            value={selectedFormType}
            onChange={e => {
              setSelectedFormType(e.value)
            }}
          />
          <FormsList
            setSelectedFormId={setSelectedFormId}
            selectedFormType={selectedFormType}
            isAllowActions={false}
          />
        </div>
        {selectedFormId && (
          <div className='col-span-12 md:col-span-6 xl:col-span-3'>
            <FormCategoriesList
              selectedFormType={selectedFormType}
              setSelectedCategoryId={setSelectedCategoryId}
              selectedFormId={selectedFormId}
              setSelectedElementFormId={setSelectedElementFormId}
              isAllowActions={false}
            />
          </div>
        )}
        {selectedCategoryId && (
          <div className='col-span-12 xl:col-span-6'>
            <VisitFormResults
              selectedCategoryId={selectedCategoryId}
              selectedFormType={selectedFormType}
              visitId={selectedVisitData?.visit_id}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default CreateVisitFormEntries
